/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Attendance_PendingInputs */

const en_admin_statistics_attendance_pending = /** @type {(inputs: Admin_Statistics_Attendance_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const de_admin_statistics_attendance_pending = /** @type {(inputs: Admin_Statistics_Attendance_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Admin_Statistics_Attendance_PendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_attendance_pending = /** @type {((inputs?: Admin_Statistics_Attendance_PendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Attendance_PendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_attendance_pending(inputs)
	return en_admin_statistics_attendance_pending(inputs)
});